import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { IAdmin } from 'types';

interface InitialState {
  isAuthed: boolean;
  currentUser?: IAdmin;
}

const initialState: InitialState = {
  isAuthed: false,
  currentUser: undefined,
};

const slice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setCurrentUser: (state, action: PayloadAction<IAdmin | undefined>) => {
      state.isAuthed = Boolean(action.payload);
      state.currentUser = action.payload;
    },
  },
});

export const {
  reducer,
  actions: { setCurrentUser },
} = slice;
